module.exports = __webpack_public_path__ + "static/media/pt-sankei-dharma-indonesia.1b86bd42.png";